import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 37.83 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.88 0C8.43.02-.02 8.56 0 19.03c.04 10.5 8.52 19 18.96 18.97 10.45-.03 18.9-8.57 18.87-19.07C37.8 8.46 29.31-.03 18.88 0Zm18.14 18.97c.02 4.8-1.83 9.18-4.88 12.47l-.02-3.62c0-.06.03-.06.03-.06-.03 0-.03-.03-.03-.03v-.03c-.2-.32-.4-.63-.63-.95-2.93-4.22-6.78-7.78-11.28-10.33l11.25-.02 5.38-.02c.13.86.18 1.69.18 2.59Zm-5.55-6.27-20.8.06v3.67c1.92.43 3.82 1.03 5.62 1.83-3.32-.9-6.81-1.27-10.77-1.26h-.14v4.72l1.09-1.1c9.76.21 18.58 4.27 25.03 10.72.14.12.27.23.38.35-.11.15-.23.26-.37.38a18.018 18.018 0 0 1-12.52 5.13C8.98 37.23.87 29.09.83 19.06.82 9.01 8.89.86 18.91.83c4.86-.02 9.3 1.9 12.54 5.06 1.97 1.86 3.5 4.19 4.48 6.8 0 0-4.46.01-4.46 0Z",
      style: {"fill":"#173d79"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "PS-logo"}) } }